import React, { Component } from 'react';

class PunchOutTransferCart extends Component {
    
    constructor(props){
        super(props);
        this.state = {}
    }

  componentDidMount() {
    const  buyerFormPostUrl = localStorage.getItem("punchOutPostUrl")
    const xmlData  = localStorage.getItem("punchOutData");

    const form = document.createElement('form');
    form.id = 'cxml_form';
    form.method = 'POST';
    form.action = buyerFormPostUrl;
    form.enctype = 'application/x-www-form-urlencoded';

    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'cXML-urlencoded';
    input.value = xmlData;

    form.appendChild(input);
    document.body.appendChild(form);
    localStorage.removeItem("punchOutPostUrl");
    localStorage.removeItem("punchOutData");
    localStorage.clear();
    form.submit();
  }

  componentWillUnmount() {
    const form = document.getElementById('cxml_form');
    if (form) {
      document.body.removeChild(form);
    }
  }

  render() {
    return <div className='punchoutTrasfeerCart'><h1><b>Transferring cart...</b></h1></div>;
  }
}

export default PunchOutTransferCart;





// WEBPACK FOOTER //
// ./src/App/components/PreLogin/PunchoutTransferCart/index.js